import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-back",
  "use": "icon-ic-back-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic-back\">\n<rect width=\"48\" height=\"48\" fill=\"#FFAAAA\" fill-opacity=\"0.01\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M30.5858 8.58578L33.4142 11.4142L20.8284 24L33.4142 36.5858L30.5858 39.4142L15.1716 24L30.5858 8.58578Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol